import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';
import Education from './education';
import Experience from './experience';
import Skills from './skills';


class Resume extends Component {
  render() {
    return(
      <div className="resume">
        <Grid>
          <Cell className="resume-left-col" col={4}>
            <h2>Marianne Pettersen</h2>
            <h4>M.Sc. in Engineering and ICT & Bachelor in Economics</h4>
            <hr style={{borderTop: '3px solid #ffffff', width: '100%'}}/>
            <p>I am a Software Engineer with a Master of Science degree in Engineering & ICT, specializing in Robotics and Automation.
              Special interests include artificial intelligence, machine learning, programming and data science.
              I have experience in many different programming languages, and my knowledge stretches from setting
              up databases with SQL, coding backend with Python/Java etc., and working with frontend with React, Javascript, HTML etc..
              I am an extremely committed, structured, and self-driven person, and I love exploring new technology, learning new things,
              and taking on new challenges. During spring of 2023 I have finished my last year of a Bachelor in Economics,
              while travelling abroad.
              I am looking for an exciting and challenging full-time position at an innovative company in Oslo during fall 2023 in the fields of software development, data science, data analysis, machine learning and economics.</p>
            <hr style={{borderTop: '3px solid #ffffff', width: '100%'}}/>
            <h5>Address</h5>
            <p>Oslo, Norway</p>
            <h5>Phone</h5>
            <p>+47 948 02 840</p>
            <h5>Email</h5>
            <p>98mpett@gmail.com</p>
            <h5>LinkedIn</h5>
            <p>linkedin.com/in/mpett</p>
            <hr style={{borderTop: '3px solid #ffffff', width: '100%'}}/>
          </Cell>
          <Cell className="resume-right-col" col={8}>
            <h2>Education</h2>

            <Education
              startYear={"August 2017"}
              endYear={"June 2022"}
              schoolName="Norwegian University of Science and Technology (NTNU)"
              schoolDescription="M.Sc. in Engineering and ICT, specializing in Robotics and Automation (Trondheim, Norway). Engineering and ICT is a civil engineering education where one
combines traditional engineering courses with a wide range of computer skills.
I specialize in engineering science, with a focus on ICT, machine learning/artificial intelligence, programming and
automation. (Trondheim, Norway)"
               />

               <Education
              startYear={"August 2021"}
              endYear={"June 2023"}
              schoolName="Norwegian University of Science and Technology (NTNU)"
              schoolDescription= "Bachelor Degree in Economics with ICT specialization. (Remote/Trondheim, Norway)"
              />

               <Education
              startYear={"September 2021"}
              endYear={"January 2022"}
              schoolName="Sapienza University of Rome"
              schoolDescription="Exchange semester in Rome filled with economic and innovation classes (Rome, Italy)"
               />

               <Education
                 startYear={"August 2014"}
                 endYear={"June 2017"}
                 schoolName="Senja Videregående Skole"
                 schoolDescription="High School (Troms, Norway)"
                  />

                    <Education
                     startYear={"September 2015"}
                     endYear={"May 2016"}
                     schoolName="Stanley Boyd High School"
                     schoolDescription="High School, Exchange Year (Stanley, Wisconsin, USA)"
                      />

                <hr style={{borderTop: '3px solid #fda07d'}} />

              <h2>Work Experience</h2>

             <Experience
              startYear={"June 2022"}
              endYear={"August 2022"}
              jobName="Software Developer Intern at Bekk Consulting"
              jobDescription="Worked 7 weeks as a summer intern and developer in an agile team of five with tasks related to accessibility.
              Together with 3 other developers and one designer I analyzed a website for accessibility,
              documented violations of the Web Content Accessibility Guidelines (WCAG),
              and fixed errors in the code to improve accessibility and usability. We also restructured the menu on the website and fixed other bugs.
              The technology stack included React with typescript, HTML and SCSS.
              (Oslo, Norway)"
              />
            <Experience
              startYear={"June 2021"}
              endYear={"August 2021"}
              jobName="Software Developer Intern at the Department of Digital Transformations at Multiconsult AS"
              jobDescription="Worked 7 weeks as a summer intern and independent programmer with tasks related
to a machine learning case and a digital twin case. Programmed mostly in Python with ML-modules such as sklearn, pandas etc., and used Microsoft
Azure Machine Learning for training ML-models. Modeled a building i Revit and used Unity3D and C# for creating a digital twin with
visualization of live temperatures. (Oslo, Norway)"
              />

            <Experience
              startYear={"February 2021"}
              endYear={"November 2021"}
              jobName="Personal Teacher at Learnlink AS"
              jobDescription="Worked as a personal teacher for students in mathematics in middle school.
              Used my pedagogical skills to communicate knowledge, motivate and guide students in the subject,
              as well as adapt learning methods to meet each student's needs. Started leading coding courses for
              kids between 7-8 years using Minecraft Education from august 2021. (Remote, Norway)"
              />

              <Experience
              startYear={"January 2021"}
              endYear={"May 2021"}
              jobName="Teaching Assistant at NTNU"
              jobDescription="Worked as a Teaching assistant in the subject TMM4275 - Knowledge Based Engineering,
              Project (Automation, Project) at NTNU. Supervised students in Siemens NX, Knowledge Fusion,
              Python and SQL in connection with automation projects. (Trondheim, Norway)"
              />

            <Experience
              startYear={"June 2020"}
              endYear={"August 2020"}
              jobName="Software Developer Intern at Finnfjord AS"
              jobDescription="Worked 6 weeks with programming in C#, JavaScript, PHP, SQL, CSS and HTML.
              Several of the languages I had only a little experience with beforehand, and thus got a steep learning curve.
               Developed a user-friendly dashboard that represented data from real-time sensor measurements from around the plant.
                In addition, I developed and deployed a game that simulates the operation of one of the smelters.
                Worked independently as a full-stack developer, with a mentor. (Finnsnes, Norway)"
              />

              <Experience
                startYear={"June 2018"}
                endYear={"July 2020"}
                jobName="Metal Furnace Operator at Finnfjord AS"
                jobDescription="Worked with operation of one of the ferrosilicon-producing furnaces at
                the plant using control systems. Adjusted the position of the electrodes in the furnace
                 to provide optimal current transfer, as well as controlling the mass level in the furnace.
                 Regularly inspected the status of electrode-fans, water and hydraulic systems, as well as
                  pressures and temperatures around the plant. (Finnsnes, Norway)"
                />

                <Experience
                startYear={"July 2014"}
                endYear={"August 2017"}
                jobName="Salesperson/Clothing Store Employee at KappAhl Finnsnes"
                jobDescription="Worked with sales, customer assistance, cleaning and other store tasks.
                Also took over the general manager's tasks during the holiday, which included national telephone meetings,
                 monthly settlements, organization of employees, report writing and other office work. (Finnsnes, Norway)"
                />

                <Experience
                startYear={"September 2014"}
                endYear={"August 2017"}
                jobName="Kiosk Employee at Mix Finnfjordbotn Storkiosk"
                jobDescription="My first job at age 14. Worked as a kiosk employee with typical tasks such as
                 customer service, cooking, cleaning and cash settlement. (Finnsnes, Norway)"
                />

                <hr style={{borderTop: '3px solid #fda07d'}} />

              <h2>Volunteer Work</h2>

                <Experience
                  startYear={"August 2017"}
                  endYear={"June 2022"}
                  jobName="Elected Class Representative for Class 2022 in Engineering and ICT"
                  jobDescription="Served as a trustee for the class, and a link between the class and the Department of Engineering. Attended meetings during the semester with other trustees from Engineering and ICT to discuss safety and well-being in the student community, as well as internal student politics."
                />
                    <Experience
                      startYear={"October 2018"}
                      endYear={"March 2020"}
                      jobName="Second Leader and Financial Manager for the class’ Excursion Committee"
                      jobDescription="Planned and organized the excursion for the class at Engineering and ICT. Was responsible for the committee bank account, budgeting, applications and other financial tasks."
                      />
                      <Experience
                      startYear={"February 2019"}
                      endYear={"October 2019"}
                      jobName="Painter and Designer at UKA cultural festival 2019"
                      jobDescription="Designed murals and posters to promote various companies such as Equinor and Deloitte, as well as painted murals during the UKA-19 cultural festival."
                      />


              <hr style={{borderTop: '3px solid #fda07d'}} />
              <h2>Skills</h2>
              <Skills
                skill="Javascript"
                progress={70}
                />
                <Skills
                  skill="HTML / CSS"
                  progress={90}
                  />
                  <Skills
                    skill="Java"
                    progress={85}
                    />
                    <Skills
                      skill="Python"
                      progress={90}
                      />
                        <Skills
                        skill="SQL"
                        progress={90}
                        />
                          <Skills
                          skill="Siemens NX / Knowledge Fusion"
                          progress={70}
                          />
                            <Skills
                            skill="MatLab"
                            progress={80}
                            />
                              <Skills
                              skill="C#"
                              progress={60}
                              />
                                <Skills
                                skill="PowerBI"
                                progress={90}
                                />
                                  <Skills
                                  skill="Azure Machine Learning"
                                  progress={40}
                                  />
                                    <Skills
                                    skill="Pandas / Tensorflow / PyTorch"
                                    progress={70}
                                    />

          </Cell>
        </Grid>
      </div>
    )
  }
}

export default Resume;



// WEBPACK FOOTER //
// ./src/components/resume.js